import { combineReducers } from "redux";
import canvasObjects from "./canvasObjectsReducer.js";

const rootReducer = combineReducers({
  canvasObjects
});

export default rootReducer;
